<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px" class="page-title">
  <a fxLayoutAlign="center center" class="back-link cursor-pointer" (click)="onBackClick()">
    <mat-icon svgIcon="expand-left"></mat-icon>
  </a>
  <h1 [style.font-size]="fontSize + 'px'" [style.font-weight]="fontWeight">{{ titleText }}</h1>
</div>
